import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function PartnerModal({ open, onClose }: Props) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8">
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />
      <div className="relative w-full max-w-[1100px] h-[88vh] bg-background rounded-[24px] overflow-hidden shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          aria-label={t("common.close")}
          className="absolute top-4 right-4 z-10 h-10 w-10 flex items-center justify-center rounded-full bg-foreground/90 text-background hover:bg-foreground transition"
        >
          <X className="h-5 w-5" />
        </button>
        <iframe
          src="https://form.fillout.com/t/dpzA2Vwsk1us"
          title="Become a partner"
          className="w-full h-full border-0"
          allow="clipboard-write"
        />
      </div>
    </div>
  );
}
